<script setup lang="ts">
  // Idioma
  const { t } = useI18n()

  useSeoMeta({ robots: 'noindex, nofollow' })

  // Layout
  definePageMeta({
    layout: 'simple'
  })

  // Login redirect logic
  const { handleLoginSuccess } = useLoginRedirect()

  // Toast para mostrar avisos de confirmación de email / Facebook
  const toast = useToast()
  const route = useRoute()
  const router = useRouter()

  function clearAuthQueryFlags() {
    const nextQuery = { ...route.query }
    delete nextQuery.error
    delete nextQuery.email_verified
    void router.replace({ query: nextQuery })
  }

  onMounted(() => {
    const error = route.query?.error
    if (error === 'facebook_email_required') {
      toast.add({
        title: t('errors.login.facebook_email_required'),
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      })
      clearAuthQueryFlags()
      return
    }

    if (error === 'email_verification_failed') {
      toast.add({
        title: t('errors.login.email_verification_failed'),
        color: 'error',
        icon: 'i-lucide-triangle-alert'
      })
      clearAuthQueryFlags()
      return
    }

    if (route.query?.email_verified === '1') {
      toast.add({
        title: t('errors.login.email_verified'),
        color: 'success',
        icon: 'i-lucide-check-circle-2'
      })
      clearAuthQueryFlags()
    }
  })

</script>

<template>
  <div class="w-full p-10">
    <div class="max-w-sm mx-auto flex flex-col gap-10">

      <h1 class="text-4xl text-center">{{ t('labels.login.title') }}</h1>

      <LoginForm 
        @login-success="() => handleLoginSuccess()"
      />

    </div>
  </div>
</template>
